import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

// Marketing Pages
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Shop from './pages/Shop';
import Training from './pages/Training';
import Gear from './pages/Gear';

// App Pages
import Login from './pages/Login';
import Billing from './pages/Billing';
import AppHome from './pages/AppHome';
import DataHub from './pages/DataHub';

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isAppRoute = location.pathname.startsWith('/app');

  return (
    <div className="flex flex-col min-h-screen">
      {!isAppRoute && <Navigation />}
      <main className="flex-1">{children}</main>
      {!isAppRoute && <Footer />}
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppLayout>
          <Routes>
            {/* Marketing Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/training" element={<Training />} />
            <Route path="/gear" element={<Gear />} />

            {/* App Routes */}
            <Route path="/app/login" element={<Login />} />
            <Route
              path="/app/billing"
              element={
                <ProtectedRoute>
                  <Billing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <AppHome />
                </ProtectedRoute>
              }
            />
            <Route
              path="/app/hub"
              element={
                <ProtectedRoute requireSubscription>
                  <DataHub />
                </ProtectedRoute>
              }
            />

            {/* 404 */}
            <Route path="*" element={
              <div className="min-h-screen flex items-center justify-center px-4">
                <div className="text-center">
                  <h1 className="text-6xl font-display font-bold text-copper mb-4">404</h1>
                  <p className="text-2xl text-text-secondary mb-8">Target not found</p>
                  <a href="/" className="btn-primary">
                    Return to Base
                  </a>
                </div>
              </div>
            } />
          </Routes>
        </AppLayout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
